import angular from 'angular'
import carCodeComponent from './carCodeComponent'
import sharingGoodsCtrl from './sharingGoodsCtrl'

import goodsInfoPage from './view/goodsInfo.html'

import { goodsInfo } from 'redevConfig'

const list = (goodsInfo && goodsInfo.list) || ''
const add = (goodsInfo && goodsInfo.add) || ''
const addCar = (goodsInfo && goodsInfo.addCar) || ''
const goodstype = (goodsInfo && goodsInfo.goodstype) || ''

const goodsInfoList = list ? require(`redevelopment/outputManage/goodsInfo/${list.templateName}`) : require('./view/goodsInfoList.html')
const goodsInfoListCtrl = list ? require(`redevelopment/outputManage/goodsInfo/${list.controllerName}`) : require('./goodsInfoListCtrl')
const goodsInfoEdit = add ? require(`redevelopment/outputManage/goodsInfo/${add.templateName}`) : require('./view/goodsInfoEdit.html')
const goodsInfoEditCtrl = add ? require(`redevelopment/outputManage/goodsInfo/${add.controllerName}`) : require('./goodsInfoEditCtrl')
const carEdit = addCar ? require(`redevelopment/outputManage/goodsInfo/${addCar.templateName}`) : require('./view/carEdit.html')
const carEditCtrl = addCar ? require(`redevelopment/outputManage/goodsInfo/${addCar.controllerName}`) : require('./carEditCtrl')
const goodsType = goodstype ? require(`redevelopment/outputManage/goodsInfo/${goodstype.templateName}`) : require('./view/goodsType.html')
const gdTypeCtrl = goodstype ? require(`redevelopment/outputManage/goodsInfo/${goodstype.controllerName}`) : require('./gdTypeCtrl')

function config($stateProvider) {
    $stateProvider.state('outputManage.ovat.goodsInfo', {
            url: '/goodsInfo',
            abstract: true,
            template: goodsInfoPage,
            title: '商品信息',
            default: 'outputManage.ovat.goodsInfo.list',
        })
        .state('outputManage.ovat.goodsInfo.add', {
            url: '/goodsInfoAdd',
            template: goodsInfoEdit,
            controller: 'goodsInfoEditCtrl',
            title: '新增货物或应税劳务、服务',
        })
        .state('outputManage.ovat.goodsInfo.edit', {
            url: '/goodsInfoEdit/:goodsId',
            template: goodsInfoEdit,
            controller: 'goodsInfoEditCtrl',
            title: '编辑货物或应税劳务、服务',
        })
        .state('outputManage.ovat.goodsInfo.list', {
            url: '/goodsInfoList',
            template: goodsInfoList,
            controller: 'goodsInfoListCtrl',
        })
        .state('outputManage.ovat.goodsInfo.goodstype', {
            url: '/goodstype/:type',
            template: goodsType,
            controller: 'gdTypeCtrl',
            title: '管理类别',
        })
        .state('outputManage.ovat.goodsInfo.addCar', {
            url: '/carAdd',
            template: carEdit,
            controller: 'carEditCtrl',
            title: '新增车辆编码',
        })
        .state('outputManage.ovat.goodsInfo.EditCar', {
            url: '/carEdit/:goodId',
            template: carEdit,
            controller: 'carEditCtrl',
            title: '编辑车辆编码',
        })
}

export default angular
    .module('outputManage.ovat.goodsInfo', [carCodeComponent])
    .config(['$stateProvider', config])
    .controller('goodsInfoEditCtrl', goodsInfoEditCtrl.default)
    .controller('goodsInfoListCtrl', goodsInfoListCtrl.default)
    .controller('gdTypeCtrl', gdTypeCtrl.default)
    .controller('carEditCtrl', carEditCtrl.default)
    .controller('sharingGoodsCtrl', sharingGoodsCtrl)
    .name


// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsInfo/index.js